// extracted by mini-css-extract-plugin
module.exports = {"videoCard":"VideosCard_videoCard__11QTt","letterHover":"VideosCard_letterHover__3gl8N","videoImage":"VideosCard_videoImage__2Bv2A","videoTitle":"VideosCard_videoTitle__1FZ03"};